import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { NubUserState } from '../types';

const initialState = {
    users: [],
    activeUser: null,
    groups: [],
    accessLevels: [],
    permissions: [],
    actionMode: 'view' as const,
    isModalOpen: false,
    isLoading: false,
    error: null,
};

export const useNubUserStore = create<NubUserState>()(
    devtools(
        (set) => ({
            ...initialState,

            setUsers: (users) => set({ users }),

            setActiveUser: (user) => set({ activeUser: user }),

            setActionMode: (mode) => set({ actionMode: mode }),

            setModalOpen: (isOpen) => set({ isModalOpen: isOpen }),

            setGroups: (groups) => set({ groups }),

            setAccessLevels: (accessLevels) => set({ accessLevels }),

            setPermissions: (permissions) => set({ permissions }),

            resetState: () => set(initialState),
        }),
        { name: 'NubUserStore' }
    )
);
